import React, { FC } from 'react';
import { LocationWithContactDto } from '@apiModels/LocationWithContactDto.csharp';


import { List } from '../Partials/List';
import { CenterContactCard } from './CenterContactCard';

interface LocationsCardsProps {
  selectedLocations: LocationWithContactDto[]
}

export const LocationsCards: FC<LocationsCardsProps> = (props) => {
  const { selectedLocations } = props;

  const mapLocationToCards = (location: LocationWithContactDto) => (
    <li key={location.id} className="centerContactCard__outer">
      <CenterContactCard {...location} />
    </li>
  )
  return (
    <List
      items={selectedLocations}
      renderItem={mapLocationToCards}
      useDefaultLayout={false}
      listClassName="locationsCards cardWrapper"
    />
  )
};
